import React, { useEffect } from "react";

const RazorpayEmiWidget = ({ amount }) => {
  // Grab the key directly
  const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY_ID;
 // console.log("Razorpay Key:", razorpayKey); // Debug log to ensure the key is being read

  useEffect(() => {
    // 1. THE ULTIMATE GUARD CLAUSE
    // Do absolutely nothing until BOTH the amount and the key are physically present
    if (!amount || !razorpayKey) {
      return;
    }

    // 2. Safely clean the number format
    const cleanNumber = Number(String(amount).replace(/[^0-9.]/g, ""));
    const amountInPaise = Math.round(cleanNumber * 100);

    const loadWidget = () => {
      if (window.RazorpayAffordabilitySuite) {
        const widgetConfig = {
          key: razorpayKey,
          amount: amountInPaise,
        };

        // Prevent duplicate widgets
        const container = document.getElementById(
          "razorpay-affordability-widget",
        );
        if (container) container.innerHTML = "";

        // Render the widget
        const rzpAffordabilitySuite = new window.RazorpayAffordabilitySuite(
          widgetConfig,
        );
        rzpAffordabilitySuite.render();
      }
    };

    // 3. Dynamically inject the script ONLY when we are ready for it
    const scriptId = "rzp-affordability-script";
    let script = document.getElementById(scriptId);

    if (!script) {
      script = document.createElement("script");
      script.id = scriptId;
      script.src =
        "https://cdn.razorpay.com/widgets/affordability/affordability.js";
      script.async = true;
      script.onload = loadWidget;
      document.body.appendChild(script);
    } else {
      // If the script is already there from a previous render, just run the widget
      setTimeout(loadWidget, 100);
    }

    // 4. Cleanup
    return () => {
      const container = document.getElementById(
        "razorpay-affordability-widget",
      );
      if (container) container.innerHTML = "";
    };
  }, [amount, razorpayKey]); // <-- Added razorpayKey as a dependency so it re-runs the moment the key arrives

  return (
    <div style={{ margin: "20px 0", minHeight: "80px" }}>
      <div id="razorpay-affordability-widget"></div>
    </div>
  );
};

export default RazorpayEmiWidget;
